import { Box, FormControl, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ControlledRadioGroup, RequiredAsterisk } from '@components';

export const PropertyType = () => {
  const { t } = useTranslation('subModules/propertyType');
  const fields: { [key: string]: string } = t('fields', {
    returnObjects: true,
  }) as { [key: string]: string };

  return (
    <Box
      id="propertyType"
      mb={3}
      data-testid="propertyTypeSubModule"
      data-tf-sensitive="true"
    >
      <Box mb={1}>
        <Typography variant="h6" component="h2">
          {t('label')}
          <RequiredAsterisk />
        </Typography>
      </Box>
      <FormControl component="fieldset">
        <ControlledRadioGroup
          name="propertyType"
          fields={fields}
          aria-labelledby="property-status-radio-buttons"
        />
      </FormControl>
    </Box>
  );
};
